import {observer} from "mobx-react";
import {Page} from "../../ui";
import {vhsDetailStore, VhsLabelPrintDialogStore} from "../../../store";
import {RefObject, useRef, useState} from "react";
import {debounce} from "../../../utils";
import {VhsDetailItem} from "./VhsDetailItem";
import './VhsDetailPage.scss'
import {DetailIntro} from "./DetailIntro";
import {VhsLabelPrintDialog} from "./VhsLabelPrintDialog";


interface ScrollContext {
    containerRef: RefObject<HTMLDivElement | null>
    updateExclusionStatus: (a: string, status: boolean) => any,
    done: () => any
}

const scrollCall: (ctx: ScrollContext) => any = debounce(({
                                                              containerRef,
                                                              done,
                                                              updateExclusionStatus
                                                          }: ScrollContext) => {
    const container = containerRef.current
    if (container) {
        const containerRect = container.getBoundingClientRect();

        for (let i = 0; i < container.children.length; i++) {
            const item = container.children.item(i)
            if (item) {
                const itemRect = item.getBoundingClientRect()
                const dataId = item.getAttribute('data-id')
                const itemTopHeight = itemRect.top + itemRect.height
                const limes = itemTopHeight - containerRect.top
                const gone = limes < 100 // adjust 60 to how many px the top item is still visible

                if (dataId) {
                    updateExclusionStatus(dataId, gone)
                }
            }
        }
        done()
    }
}, 100)


const VhsDetailPage = observer(function VhsDetailPage() {
    const display = vhsDetailStore.vin!
    const data = vhsDetailStore.data

    const containerRef = useRef<HTMLDivElement>(null);
    const [labelPrintDialogStore] = useState(new VhsLabelPrintDialogStore())

    function updateExclusionStatus(key: string, excluded: boolean) {
        vhsDetailStore.updateExcluded(key, excluded)
    }

    return <Page
        cssSuffix={"vhs-detail"}
        topper={<DetailIntro printDialogStore={labelPrintDialogStore}/>}
        breadcrumb={[
            {
                link: '/vhs',
                label: `Fahrzeughistorie`
            },
            {
                link: `/vhs/${vhsDetailStore.vin}`,
                label: display
            }
        ]}
    >
        <VhsLabelPrintDialog store={labelPrintDialogStore} />
        <div
            ref={containerRef}
            onScroll={e => {
                scrollCall({
                    containerRef,
                    updateExclusionStatus,
                    done: () => {
                        vhsDetailStore.recalculateOverview()
                    }
                })
            }}
            style={{
                flex: '1',
                overflow: 'auto',
                display: 'flex',
                paddingBottom: '1em',
                flexDirection: 'column'
            }}>
            {data.map((e, index) => <VhsDetailItem
                key={e.id}
                data={e}
                excluded={vhsDetailStore.isExcluded(e.id)}
                first={index === 0}
                pos={index % 2 === 0 ? 'even' : 'odd'}
            />)}
        </div>
    </Page>
})

export {
    VhsDetailPage
}
